var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/delete") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/delete",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7907906,7.20920944 C17.0482791,7.46669799 17.0680859,7.87186303 16.850211,8.15207103 L16.7907906,8.21936199 L13.01,12 L16.7907906,15.780638 C17.0697365,16.0595839 17.0697365,16.5118446 16.7907906,16.7907906 C16.533302,17.0482791 16.128137,17.0680859 15.847929,16.850211 L15.780638,16.7907906 L12,13.01 L8.21936199,16.7907906 C7.94041606,17.0697365 7.48815536,17.0697365 7.20920944,16.7907906 C6.9517209,16.533302 6.93191409,16.128137 7.14978901,15.847929 L7.20920944,15.780638 L10.99,12 L7.20920944,8.21936199 C6.93026352,7.94041606 6.93026352,7.48815536 7.20920944,7.20920944 C7.46669799,6.9517209 7.87186303,6.93191409 8.15207103,7.14978901 L8.21936199,7.20920944 L12,10.99 L15.780638,7.20920944 C16.0595839,6.93026352 16.5118446,6.93026352 16.7907906,7.20920944 Z",
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.047e4f7a85135adc984c68388657fb81.svg";
export { ForwardRef as ReactComponent };